import { create, update } from '@/api/contacts';
import genererGuid from '@/services/general/genererGuid';
import messageSucces from '@/services/general/messageSucces';

export default async function saveContact(isEditContact, idTiers, contact, contacts, i18n) {
  let messageToast = '';
  if (isEditContact
    && contact.utilisateur
    && !contact.utilisateur.motPasse) contact.utilisateur.motPasse = null;
  if (idTiers && !isEditContact) {
    contact.tiersId = idTiers;
    const response = await create(contact);
    const contactResponse = response.data.result;
    if (contact.contactsTiers?.length > 0) {
      contactResponse.contactsTiers = contact.contactsTiers;
    }
    contact.id = contactResponse.id;
    contacts.push(contactResponse);
    messageToast = i18n.t('editionContact.messages.successCreation');
  } else if (idTiers && isEditContact) {
    await update(contact);
    const ancienContact = contacts.find((el) => { return el.id === contact.id; });
    contacts.splice(contacts.indexOf(ancienContact), 1, contact);
    messageToast = i18n.t('editionContact.messages.successChange');
  } else if (!idTiers && !isEditContact) {
    contact.guid = genererGuid();
    contacts.push(contact);
    messageToast = i18n.t('editionContact.messages.successCreation');
  } else if (!idTiers && isEditContact) {
    const ancienContact = contacts.find((el) => { return el.guid === contact.guid; });
    contacts.splice(contacts.indexOf(ancienContact), 1, contact);
    messageToast = i18n.t('editionContact.messages.successChange');
  }
  messageSucces(messageToast);
}
